import { render } from "./ConsultIcon.vue?vue&type=template&id=df96535e&scoped=true"
import script from "./ConsultIcon.vue?vue&type=script&lang=js"
export * from "./ConsultIcon.vue?vue&type=script&lang=js"

import "./ConsultIcon.vue?vue&type=style&index=0&id=df96535e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df96535e"]])

export default __exports__